const registry = /* @__PURE__ */ Object.create(null), helpers = [
  // One of these things is not like the others...
  "Array",
  "Browser",
  ["Css", "CSSHelper"],
  "Date",
  "Dom",
  "Event",
  "Function",
  "Object",
  "String",
  "TimeZone",
  "Version"
].map((el) => Array.isArray(el) ? el : [el, `${el}Helper`]), mapify = (entries) => Object.assign(/* @__PURE__ */ Object.create(null), Object.fromEntries(entries)), byName = mapify(helpers), byType = mapify(helpers.map(([k, v]) => [v, k])), denied = (reason) => (obj, name) => {
  throw new Error(`Cannot ${reason} "Helpers.${name}": object is readonly`);
}, Helpers = new Proxy(registry, {
  defineProperty: denied("define property"),
  deleteProperty: denied("delete"),
  set: denied("assign"),
  get(obj, name) {
    const ret = registry[name];
    if (!ret) {
      throw new Error(`Property not defined "Helpers.${name}": ${name in byName ? `import ${byName[name]} before using it` : `invalid helper name`}`);
    }
    return ret;
  }
  // we don't need any other getter traps because we populate "registry" (the proxy target) below.
});
Object.defineProperty(registry, "register", {
  // not enumerable, configurable, writable
  value(helper) {
    const name = helper.$name, key = byType[name];
    registry[key] = helper;
  }
});
helpers.forEach((ent) => registry[ent[0]] = null);
var Helpers_default = Helpers;
export {
  Helpers_default as default
};
